import Icon from '../components/Icon.vue'

Icon.register({
  'align-right': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M16 224c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h416c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-416zM432 416c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-416c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h416zM435.2 32c7.1 0 12.8 5.7 12.8 12.8v0 38.3 0c0 7.1-5.7 12.8-12.8 12.8h0-262.3 0c-7.1 0-12.8-5.7-12.8-12.8v0-38.3 0c0-7.1 5.7-12.8 12.8-12.8h0 262.3zM435.2 288c7.1 0 12.8 5.7 12.8 12.8v0 38.3 0c0 7.1-5.7 12.8-12.8 12.8h0-262.3 0c-7.1 0-12.8-5.7-12.8-12.8v0-38.3 0c0-7.1 5.7-12.8 12.8-12.8h0 262.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/align-right.js
// module id = 594
// module chunks = 0